import { render, staticRenderFns } from "./FbPageSearch.vue?vue&type=template&id=143b3ca2&scoped=true"
import script from "./FbPageSearch.vue?vue&type=script&lang=js"
export * from "./FbPageSearch.vue?vue&type=script&lang=js"
import style0 from "./FbPageSearch.vue?vue&type=style&index=0&id=143b3ca2&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143b3ca2",
  null
  
)

export default component.exports